import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { TParametrosPagamentoComValor } from "./CardValores";
import { useMemo } from "react";

export default function DialogDetalheParcelas({
    open,
    onClose,
    parametros
}: DialogDetalheParcelasProps) {

    const valorTotalComJuros = useMemo(() => parametros.parcelas.reduce((acc, valor) => acc + valor.valor, 0), [parametros]);

    const valorTotal = useMemo(() => {
        return parametros.valor
    }, [parametros.valor])

     const prctDiferencaTotal = useMemo(() => {
            let valorTotalPedido = valorTotal
    
            const diferenca = valorTotalComJuros - valorTotalPedido;
            const aumentoPercentual = (diferenca / valorTotalPedido) * 100;
    
            return `${aumentoPercentual.toFixed(2)}%`;
        }, [valorTotal, valorTotalComJuros])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title"><b>Parcelas</b></DialogTitle>
            <DialogContent>
                <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Parcela</b></TableCell>
                                <TableCell align="right"><b>Vencimento</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                parametros.parcelas.map((item: TParcela, index: number) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {`${index + 1}ª ${formatarValorMonetario(item.valor)}`}
                                            </TableCell>
                                            <TableCell sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                gap: 0.5
                                            }}
                                            >
                                                {item.vencimento}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <b>Valor total</b>
                                </TableCell>
                                <TableCell align="right"><b>{formatarValorMonetario(valorTotalComJuros)} <i>({prctDiferencaTotal})</i></b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}


interface DialogDetalheParcelasProps {
    open: boolean;
    onClose: () => void;
    parametros: TParametrosPagamentoComValor
}

type TParcela = {
    valor: number,
    vencimento: string
}
